import React, { createContext, FC, ReactNode, useCallback, useContext, useMemo } from 'react';

export const SIDEBAR_COLLAPSE_EVENT = 'zakeke:request-sidebar-collapse';
export const OPEN_AGENT_GUIDE_EVENT = 'zakeke:open-agent-guide';

export function extractZendeskArticleId(value: string): string {
    const trimmed = value.trim();
    if (/^\d+$/.test(trimmed)) return trimmed;
    return trimmed.match(/\/articles\/(\d+)/)?.[1] ?? '';
}

interface InlineHelpContextValue {
    openHelpGuide: (articleId: string) => void;
}

const InlineHelpContext = createContext<InlineHelpContextValue | null>(null);

export const useInlineHelp = () => {
    const context = useContext(InlineHelpContext);

    if (!context) {
        throw new Error('useInlineHelp must be used within an InlineHelpLayout.');
    }

    return context;
};

export interface InlineHelpLayoutProps {
    children: ReactNode;
}

export const InlineHelpLayout: FC<InlineHelpLayoutProps> = ({ children }) => {
    const openHelpGuide = useCallback((value: string) => {
        const articleId = extractZendeskArticleId(value);
        if (!articleId) return;
        window.dispatchEvent(new CustomEvent(OPEN_AGENT_GUIDE_EVENT, { detail: { articleId } }));
    }, []);
    const contextValue = useMemo(() => ({ openHelpGuide }), [openHelpGuide]);

    return <InlineHelpContext.Provider value={contextValue}>{children}</InlineHelpContext.Provider>;
};
